var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebFeature4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 45,
    viewBox: "0 0 48 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5076 1.13599H5.10763C3.0116 1.13599 1.30762 2.83997 1.30762 4.936V40.136C1.30762 42.232 3.0116 43.936 5.10763 43.936H43.5076C45.6036 43.936 47.3076 42.232 47.3076 40.136V4.936C47.3076 2.83997 45.6036 1.13599 43.5076 1.13599ZM2.50769 4.936C2.50769 3.50199 3.67367 2.33601 5.10768 2.33601H43.5077C44.9417 2.33601 46.1076 3.50199 46.1076 4.936V9.13598H2.5078L2.50769 4.936ZM43.5076 42.7359H5.10763C3.67362 42.7359 2.50764 41.5699 2.50764 40.1359V10.336H46.1075V40.1359C46.1075 41.5699 44.9416 42.7359 43.5076 42.7359Z",
    fill: "url(#paint0_linear_169_4843)",
    stroke: "url(#paint1_linear_169_4843)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2679 4.57593C6.6279 4.57593 6.10791 5.09591 6.10791 5.73591C6.10791 6.37591 6.6279 6.8959 7.2679 6.8959C7.9079 6.8959 8.42788 6.37591 8.42788 5.73591C8.42788 5.09591 7.9079 4.57593 7.2679 4.57593Z",
    fill: "url(#paint2_linear_169_4843)",
    stroke: "url(#paint3_linear_169_4843)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0679 4.57593C11.4279 4.57593 10.908 5.09591 10.908 5.73591C10.908 6.37591 11.4279 6.8959 12.0679 6.8959C12.7079 6.8959 13.2279 6.37591 13.2279 5.73591C13.2279 5.09591 12.7079 4.57593 12.0679 4.57593Z",
    fill: "url(#paint4_linear_169_4843)",
    stroke: "url(#paint5_linear_169_4843)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8678 4.57593C16.2278 4.57593 15.7078 5.09591 15.7078 5.73591C15.7078 6.37591 16.2278 6.8959 16.8678 6.8959C17.5078 6.8959 18.0277 6.37591 18.0277 5.73591C18.0277 5.09591 17.5078 4.57593 16.8678 4.57593Z",
    fill: "url(#paint6_linear_169_4843)",
    stroke: "url(#paint7_linear_169_4843)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1052 15.3401C12.8217 15.3401 7.70752 20.4545 7.70752 26.7378C7.70752 33.021 12.822 38.1355 19.1052 38.1355C25.3885 38.1355 30.5029 33.021 30.5029 26.7378C30.5029 20.4545 25.3885 15.3401 19.1052 15.3401ZM28.7058 25.8609H19.9821V17.1372C24.5998 17.5551 28.2883 21.2434 28.7058 25.8609ZM9.46049 26.7377C9.46049 21.7168 13.3212 17.5815 18.2284 17.1371V26.7377C18.2284 26.8722 18.2605 27.0037 18.319 27.1235L22.5538 35.7335C21.4812 36.1456 20.3209 36.3823 19.1051 36.3823C13.7861 36.3823 9.46049 32.0571 9.46049 26.7377ZM24.1232 34.9557L20.511 27.6142H28.7027C28.4222 30.7238 26.6542 33.4038 24.1232 34.9557Z",
    fill: "url(#paint8_linear_169_4843)",
    stroke: "url(#paint9_linear_169_4843)",
    strokeWidth: 1.46128
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3287 17.5357H39.9261C40.1169 17.5357 40.2709 17.2677 40.2709 16.9357C40.2709 16.6037 40.1169 16.3357 39.9261 16.3357H35.3287C35.1379 16.3357 34.9839 16.6037 34.9839 16.9357C34.9839 17.2677 35.1379 17.5357 35.3287 17.5357Z",
    fill: "url(#paint10_linear_169_4843)",
    stroke: "url(#paint11_linear_169_4843)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3287 30.3355H39.9261C40.1169 30.3355 40.2709 30.0675 40.2709 29.7355C40.2709 29.4035 40.1169 29.1355 39.9261 29.1355H35.3287C35.1379 29.1355 34.9839 29.4035 34.9839 29.7355C34.9839 30.0675 35.1379 30.3355 35.3287 30.3355Z",
    fill: "url(#paint12_linear_169_4843)",
    stroke: "url(#paint13_linear_169_4843)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6845 22.7356H35.3287C35.1379 22.7356 34.9839 23.0036 34.9839 23.3356C34.9839 23.6676 35.1379 23.9356 35.3287 23.9356H42.6845C42.8753 23.9356 43.0293 23.6676 43.0293 23.3356C43.0293 23.0036 42.8753 22.7356 42.6845 22.7356Z",
    fill: "url(#paint14_linear_169_4843)",
    stroke: "url(#paint15_linear_169_4843)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.264 35.5354H35.2651C35.1095 35.5354 34.9839 35.8034 34.9839 36.1354C34.9839 36.4674 35.1095 36.7354 35.2651 36.7354H41.264C41.4196 36.7354 41.5452 36.4674 41.5452 36.1354C41.5452 35.8034 41.4196 35.5354 41.264 35.5354Z",
    fill: "url(#paint16_linear_169_4843)",
    stroke: "url(#paint17_linear_169_4843)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_169_4843",
    x1: -10.778,
    y1: 258.159,
    x2: 153.969,
    y2: 159.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_169_4843",
    x1: -10.778,
    y1: 258.159,
    x2: 153.969,
    y2: 159.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_169_4843",
    x1: 5.49838,
    y1: 18.5079,
    x2: 14.1107,
    y2: 13.7293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_169_4843",
    x1: 5.49838,
    y1: 18.5079,
    x2: 14.1107,
    y2: 13.7293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_169_4843",
    x1: 10.2984,
    y1: 18.5079,
    x2: 18.9107,
    y2: 13.7293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_169_4843",
    x1: 10.2984,
    y1: 18.5079,
    x2: 18.9107,
    y2: 13.7293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_169_4843",
    x1: 15.0982,
    y1: 18.5079,
    x2: 23.7105,
    y2: 13.7293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_169_4843",
    x1: 15.0982,
    y1: 18.5079,
    x2: 23.7105,
    y2: 13.7293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_169_4843",
    x1: 1.71845,
    y1: 152.231,
    x2: 86.3404,
    y2: 105.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_169_4843",
    x1: 1.71845,
    y1: 152.231,
    x2: 86.3404,
    y2: 105.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_169_4843",
    x1: 33.5948,
    y1: 23.5421,
    x2: 37.2745,
    y2: 14.5469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_169_4843",
    x1: 33.5948,
    y1: 23.5421,
    x2: 37.2745,
    y2: 14.5469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_169_4843",
    x1: 33.5948,
    y1: 36.3419,
    x2: 37.2745,
    y2: 27.3467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_169_4843",
    x1: 33.5948,
    y1: 36.3419,
    x2: 37.2745,
    y2: 27.3467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_169_4843",
    x1: 32.8701,
    y1: 29.942,
    x2: 35.5026,
    y2: 20.1492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_169_4843",
    x1: 32.8701,
    y1: 29.942,
    x2: 35.5026,
    y2: 20.1492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_169_4843",
    x1: 33.26,
    y1: 42.7418,
    x2: 36.382,
    y2: 33.2704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_169_4843",
    x1: 33.26,
    y1: 42.7418,
    x2: 36.382,
    y2: 33.2704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBFFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444811,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671214,
    stopColor: "#94E7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34D399"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebFeature4);
export default __webpack_public_path__ + "static/media/web_feature_4.cbc4b1ed2ca3d883fe49c16e54d9fe02.svg";
export { ForwardRef as ReactComponent };